import { useCurrentUser } from 'context'

export const hasPermission = (permission: string[]) => {
  const { currentUser } = useCurrentUser()
  if (!currentUser) return false
  return permission.some(p => currentUser.profile_used.includes(p))
}
